/**
 * App Version Configuration
 * Imported from package.json to maintain single source of truth
 */

// Import version from package.json
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;
